import { STORAGE_KEY } from '@/constant/constant';
import { LogJsError } from '../service/monitor';
import { getLocal } from '@/utils/storage';
/**
 * 统一处理 catch 中吞掉的错误：仅在开启 debug 时输出，避免空 catch 且不打扰生产环境。
 * 使用方式：catch (e) { catchLog('Scope', e); } 或 .catch((e) => catchLog('Scope', e))
 */

function isDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return (getLocal(STORAGE_KEY.DEBUG) ?? '').includes('cartsee:');
  } catch {
    return false;
  }
}

export function catchLog(scope: string, error: unknown): void {
  if (!isDebugEnabled()) return;
  try {
    console.warn(`[cartsee:${scope}]`, error);
    LogJsError(error)
  } catch {
    // 极端情况下 localStorage 或 console 不可用
  }
}
